<template>
  <SelectGrid ref="gridRef" selection-mode="single" :page-size="5" :grid-height="350" :disabled="tipoReadOnly"
    :placeholder="$t('tickets.form.factura_placeholder')" value-expr="Id" :display-expr="displayFactura" key-api="Id"
    :load-data="cargarFacturasTicket" :columns="columnasFacturaTicket" :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)" />
</template>

<script setup lang="ts">
import SelectGrid from "@/.shared/components/SelectGrid.vue";
import { computed, ref } from "vue";
import { useIntl } from "@services/i18n";
import { useApi } from "@api/integration";
import type { CreateTicket } from "@/.shared/components/soporte/models/CreateTicket";
import type { DXLoadOptions } from "@api/api";

const props = defineProps<{
  model: CreateTicket;
  tipoReadOnly: boolean;
  isCreatorSelectable: boolean;
  modelValue: string[];
}>();

defineEmits<{
  (e: "update:modelValue", v: string[]): void;
}>();

const api = useApi();
const intl = useIntl();
const gridRef = ref<InstanceType<typeof SelectGrid>>();

const columnasFacturaTicket = computed(() => [
  { dataField: "IdentificadorBorrador", caption: intl.i18n.t("tickets.form.factura_col_borrador"), minWidth: 220 },
  //{ dataField: "Identificador", caption: intl.i18n.t("tickets.form.factura_col_codigo") },
  { dataField: "FechaEmision", caption: intl.i18n.t("tickets.form.factura_col_fecha"), dataType: "date" },
  { dataField: "ImporteTotal", caption: intl.i18n.t("tickets.form.factura_col_importe"), dataType: "number" },
  { dataField: "Estado", caption: intl.i18n.t("tickets.form.factura_col_estado") },
  { dataField: "TieneTicketSoporteAbierto", caption: intl.i18n.t("tickets.form.factura_col_ticket_abierto"), dataType: "boolean", template: "booleanTemplate" }
]);

function displayFactura(data: any) {
  const borrador = data.IdentificadorBorrador ?? "";
  const id = data.Identificador ?? "";
  return [borrador, id].filter(Boolean).join(" — ") || String(data.Id);
}

const cargarFacturasTicket = async (options: DXLoadOptions) => {
  const q = options as DXLoadOptions;
  if (props.isCreatorSelectable) {
    return await api.callStandardApi(
      "getFacturasForGridSoporte",
      { showLoading: false },
      props.model?.IdUsuario ?? undefined,
      q
    );
  }
  return await api.callStandardApi("getFacturasMyCompanyForGrid", { showLoading: false }, q);
};

defineExpose({
  clearSelection: () => gridRef.value?.clearSelection(),
  refreshGrid: () => gridRef.value?.refreshGrid(),
  getSelectedRowsData: () => gridRef.value?.getSelectedRowsData() ?? Promise.resolve([])
});
</script>
